import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Employee } from '@app/_models/_DTOs/employee';
import { ITuple } from '@app/_models/tuple';
import { Asset } from '@app/_models/_DTOs/asset';

@Injectable({ providedIn: 'root' })
export class EmployeeService extends DataService<Employee> {
    constructor(http: HttpClient) {
        super(http, "api/employees")
    }

    getAssetsPage(employeeId: number, pageIndex: number, pageSize: number) {
        let params = new HttpParams()
            .append('pageIndex', `${pageIndex}`)
            .append('pageSize', `${pageSize}`)
        return this.http.get<ITuple<Asset>>(`${environment.apiUrl}/${this.endpoint}/assets/${employeeId}/`, { params });
    }
}